module.exports = __webpack_public_path__ + "static/img/2.452acc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/search/2.png
// module id = GEuF
// module chunks = 1